import { EntityType, promoCardSelectedContent } from "../../models";

export const MIN_TRACK_ALBUM_SEARCH_LENGTH = 2;

export const normalizeTrackAlbumSearchQuery = (query: string): string =>
    query.trim();

export const isTrackAlbumSearchQueryValid = (query: string): boolean =>
    normalizeTrackAlbumSearchQuery(query).length >=
    MIN_TRACK_ALBUM_SEARCH_LENGTH;

export const isPromoCardContinueDisabled = (
    selectedEntity: EntityType,
    selectedContent?: promoCardSelectedContent
): boolean => {
    const isTrackOrAlbumEntitySelected =
        selectedEntity === EntityType.Track ||
        selectedEntity === EntityType.Album;

    return (
        isTrackOrAlbumEntitySelected && selectedContent?.type !== selectedEntity
    );
};
